var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 12px;\n  margin-bottom: 4px;\n"], ["\n  margin-top: 12px;\n  margin-bottom: 4px;\n"])));
var Descriptor = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n  margin: 0 8px 8px 0;\n  padding: 3px 8px;\n  background-color: rgba(145, 158, 171, 0.16);\n  border-radius: 12px;\n  color: #637381;\n  font-size: 13px;\n\n  span {\n    font-size: 11px;\n    font-weight: 600;\n    opacity: 0.56;\n  }\n"], ["\n  display: inline-block;\n  margin: 0 8px 8px 0;\n  padding: 3px 8px;\n  background-color: rgba(145, 158, 171, 0.16);\n  border-radius: 12px;\n  color: #637381;\n  font-size: 13px;\n\n  span {\n    font-size: 11px;\n    font-weight: 600;\n    opacity: 0.56;\n  }\n"])));
var CuppingDescriptors = function (_a) {
    var descriptors = _a.descriptors;
    if (!descriptors)
        return null;
    return (React.createElement(Wrapper, { className: "descriptors" }, Object.entries(descriptors).map(function (_a, i) {
        var descriptor = _a[0], count = _a[1];
        return (React.createElement(Descriptor, { key: "descriptors-".concat(i) },
            descriptor,
            " ",
            count > 1 && React.createElement("span", null,
                "+",
                count - 1)));
    })));
};
export default CuppingDescriptors;
var templateObject_1, templateObject_2;
